export default __webpack_public_path__ + "static/media/rightButton.5e8daea7.svg";